
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mahashivratri/tamil-thembu",
      function () {
        return require("private-next-pages/mahashivratri/tamil-thembu/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mahashivratri/tamil-thembu"])
      });
    }
  